import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['slide'];

  static values = { index: Number };

  initialize() {
    this.indexValue = this.slideTarget.getAttribute('image-number') || 0

    this.showCurrentSlide();
    if (this.data.get('loop') && this.slideTargets.length > 0) {
      this.loopSlides();
    }
  }

  loopSlides(){
    const ctrl = this;
    setInterval( function(){
      if (ctrl.indexValue === ctrl.slideTargets.length - 1) {
        ctrl.indexValue = 0;
      } else {
        ctrl.indexValue += 1;
      }
      ctrl.showCurrentSlide();
    }, 5000);
  }

  next() {
    if (this.indexValue === this.slideTargets.length - 1) {
      this.indexValue = 0;
    } else {
      this.indexValue += 1;
    }
    this.showCurrentSlide();
  }

  previous() {
    if (this.indexValue === 0) {
      this.indexValue = this.slideTargets.length - 1;
    } else {
      this.indexValue -= 1;
    }
    this.showCurrentSlide();
  }

  showCurrentSlide() {
    this.slideTargets.forEach((element, elmPos) => {
      element.hidden = elmPos !== this.indexValue; // eslint-disable-line no-param-reassign
    });
  }

  resetSlider() {
    this.indexValue = this.slideTarget.getAttribute('image-number')
    this.showCurrentSlide();
  };
}
